import React, { useState } from 'react'
import { useEffect } from 'react'
import _ from 'lodash'
import { AppInput, Input } from 'Components/form'
import { appConfig } from 'config'
import { Col, Row, Space } from 'antd'
import MyGoogleMap from './GoogleMap'
import { PrimaryButton } from 'Components/button'
const PinCustomer = `${appConfig.publicAssetEndpoint}/etc/pin_customer.png`
const PinMerchant = `${appConfig.publicAssetEndpoint}/etc/pin.png`

const MapWithASearchBox = props => {
  const { googleMapURL, lat = 0, long = 0, onDragEnd = () => {}, icon = 'merchant' } = props
  const [inputLat, setLat] = useState(0)
  const [inputLong, setLong] = useState(0)
  const [latitude, setLatitude] = useState(lat)
  const [longitude, setLongitude] = useState(long)

  useEffect(() => {
    setLongitude(long)
    setLatitude(lat)
  }, [lat, long])

  const onSearch = () => {
    setLatitude(inputLat)
    setLongitude(inputLong)
    onDragEnd(inputLat, inputLong)
  }

  return (
    <Row style={{ width: '100%' }}>
      <Col span={24}>
        <Space wrap>
          <AppInput
            style={{ width: '120px' }}
            name="latitude"
            label="Latitude"
            isRequired={false}
            isError={false}
            value={inputLat}
            type="number"
            onChange={val => setLat(parseFloat(val))}
          />
          <AppInput
            name="longitude"
            label="Longitude"
            isRequired={false}
            isError={false}
            value={inputLong}
            type="number"
            onChange={val => setLong(parseFloat(val))}
          />
          <PrimaryButton text={'ค้นหา'} onClick={onSearch} />
        </Space>
      </Col>
      <Col span={24}>
        <MyGoogleMap
          lat={latitude}
          long={longitude}
          onDragEnd={onDragEnd}
          draggable={true}
          icon={icon}
          isMarkerShown={true}
        />
      </Col>
    </Row>
  )
}

export default MapWithASearchBox
